module.exports = __webpack_public_path__ + "static/img/jpg.0afeb751.png";